"use strict";exports.isBrowser=function(){try{return"undefined"!=typeof window}catch(r){return!1}};
//# sourceMappingURL=isBrowser.cjs.map
